import React, { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './QrModal.css';

export default function QrModal({ peer, onClose }) {
  const { getAccessTokenSilently } = useAuth0();
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(null);
  // Track the object URL in a ref so the cleanup function can revoke it even
  // if the modal is closed while the fetch is still in-flight.
  const objectUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const token = await getAccessTokenSilently();
        const res = await fetch(`/api/vpn/peers/${peer.id}/qr`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Failed to load QR code');
        const blob = await res.blob();
        if (cancelled) return; // modal was closed while fetching — discard result
        const url = URL.createObjectURL(blob);
        objectUrlRef.current = url;
        setSrc(url);
      } catch (e) {
        if (!cancelled) setError(e.message);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [peer.id, getAccessTokenSilently]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{peer.pretty_name || `Peer ${peer.id}`}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <p className="modal-sub">{peer.ip} · Scan with WireGuard app</p>
        <div className="modal-qr">
          {error && <p className="qr-error">{error}</p>}
          {!error && !src && <div className="qr-spinner" />}
          {src && <img src={src} alt="WireGuard QR Code" />}
        </div>
      </div>
    </div>
  );
}
